/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface CheckoutSessionDTO
 */
export interface CheckoutSessionDTOOptional {
  /**
   *
   * @type {string}
   * @memberof CheckoutSessionDTO
   */
  checkoutSecret?: string;
}

export interface CheckoutSessionDTO extends CheckoutSessionDTOOptional {
  /**
   *
   * @type {string}
   * @memberof CheckoutSessionDTO
   */
  checkoutSecret?: string;
}

export interface CheckoutSessionDTOTrackedI {
  /**
   *
   * @type {string}
   * @memberof CheckoutSessionDTO
   */
  checkoutSecret?: string;
  checkoutSecretIsSet: boolean;
}

transformDatesMap.set(
  "CheckoutSessionDTO",
  function (model: CheckoutSessionDTO) {},
);

export type CheckoutSessionDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  checkoutSecret: PropertyMeta<MetaTypeBase<string>>;
}>;

export var CheckoutSessionDTOMeta: CheckoutSessionDTOMetaI =
  {} as CheckoutSessionDTOMetaI;
CheckoutSessionDTOMeta = typeMeta("CheckoutSessionDTO", {
  checkoutSecret: propertyMeta(
    "checkoutSecret",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
});

const metaI = CheckoutSessionDTOMeta;

registerMeta(() => {});

export class CheckoutSessionDTOTracked implements CheckoutSessionDTOTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  checkoutSecret__I?: string = undefined;
  checkoutSecretIsSet: boolean = false;
  set checkoutSecret(v: undefined | string) {
    if (v !== undefined) {
      this.checkoutSecret__I = v;
      this.checkoutSecretIsSet = true;
    } else {
      this.checkoutSecret__I = v || undefined;
      this.checkoutSecretIsSet = false;
    }
    this.changeTracker = true;
  }
  get checkoutSecret() {
    return this.checkoutSecret__I;
  }
  constructor(config?: CheckoutSessionDTOOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: CheckoutSessionDTOOptional,
    options?: AssignOptions,
  ): CheckoutSessionDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.checkoutSecret &&
      this.checkoutSecretApplyFilter(optionsRequired.filter)
    ) {
      this.checkoutSecret = config.checkoutSecret;
      if (optionsRequired.unassign) this.checkoutSecretIsSet = false;
      else this.checkoutSecretIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): CheckoutSessionDTOTrackedI {
    const cloned = {} as CheckoutSessionDTOTrackedI;
    if (
      this.checkoutSecretIsSetDeep() &&
      this.checkoutSecretApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.checkoutSecretIsSet = true;
      cloned.checkoutSecret = this.checkoutSecret;
    } else {
      //cloned.checkoutSecretIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): CheckoutSessionDTOTrackedI {
    if (!this.checkoutSecretApplyFilter(filter))
      this.checkoutSecretIsSet = false;

    return this;
  }
  checkoutSecretApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CheckoutSessionDTOMeta.checkoutSecret,
      CheckoutSessionDTOMeta,
      this.checkoutSecret,
      this,
    );
  }
  checkoutSecretIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.checkoutSecretIsSet && this.checkoutSecretApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.checkoutSecretIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
